import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: () => import(/* webpackChunkName: "home" */ "@/views/HomeView.vue"),
  },
  {
    path: "/partner",
    name: "partner",
    component: () => import(/* webpackChunkName: "partner" */ "@/views/PartnerView.vue"),
  },
  {
    path: "/downloads",
    name: "downloads",
    component: () => import(/* webpackChunkName: "downloads" */ "@/views/DownloadsView.vue"),
  },
  {
    path: "/account",
    name: "Account",
    component: () => import(/* webpackChunkName: "account" */ "@/views/AccountView.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/login-callback",
    name: "login-callback",
    component: () => import(/* webpackChunkName: "account" */ "@/components/LoginCallback.vue"),
  },
  {
    path: "/partner-uebersicht",
    name: "partner-uebersicht",
    component: () => import(/* webpackChunkName: "partner" */ "@/views/PartnerOverview.vue"),
  },
  {
    path: "/geo-kalenderblatt.html",
    redirect: "/downloads",
  },
  {
    path: "/geo-kalenderblatt-reply.html",
    redirect: "/",
  },
  {
    path: "/alle-vorteile.html",
    redirect: "/",
  },
  {
    path: "/geo-partner.html",
    redirect: "/",
  },
  {
    path: "/geocard-digital.html",
    redirect: "/",
  },
  {
    path: "/geo-engagement.html",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;

router.beforeEach((to, from, next) => {
  const requiresAuth = to.meta.requiresAuth;
  const token = localStorage.getItem("gcU");

  if (requiresAuth && !token) {
    // auth needed but no token present
    next({
      name: "Login",
      query: { redirect: to.fullPath },
    });
  } else {
    // no auth needed or token present
    next();
  }
});
